import axios from 'axios';

export default class MoviestoreService {

    _baseUrl = 'https://60d598c7943aa60017768a9b.mockapi.io/movies';

    getMovieById = async (id) => {
        const { data } = await axios.get(this._baseUrl + `/${id}`);
        return { data };
    };

    getMoviesById = async ([favoritesMoviesId, favoritesPremieresId]) => {
        const { data } = await axios.get(this._baseUrl);
        const favoritesMovies = data.filter((movie) => favoritesMoviesId.includes(Number(movie.id)));
        const favoritesPremieres = data.filter((movie) => favoritesPremieresId.includes(Number(movie.id)));

        return { favoritesMovies, favoritesPremieres };
    };

    getPostersSimilarMovies = async (ids) => {
        const { data } = await axios.get(this._baseUrl);
        const similarMovies = data.filter((movie) => ids.includes(Number(movie.id))).map((movie) => {

            return {
              id: movie.id,
              title: movie.title,
              similar_frame: movie.similar_frame,
            };
        });

        return similarMovies;
    };

    getMovies = async (type) => {
        if (type === undefined) {
            const { data } = await axios.get(this._baseUrl);
            return { data };
        }
        const { data } = await axios.get(this._baseUrl + `?type=${type}`);

        return { data };
    };

    getPremieres = async () => {
        const { data } = await axios.get(this._baseUrl);
        const premieres = data.filter((movie) => (new Date(movie.released) - new Date()) > 0);

        return premieres;
    };

    getImdbRating = async (id) => {
        const { data } = await axios.get(`https://www.omdbapi.com/?apikey=78584b3c&i=tt${id}`);

        return { imdbRating: data.imdbRating };
    };
}